module.exports = __webpack_public_path__ + "img/warning-notification-icon.769f2275.png";